import React, { useState, useEffect } from "react";
import { Column, Table, SortDirection } from "react-virtualized";
import "react-virtualized/styles.css";
import {
  Checkbox,
  Paper,
  Typography,
  IconButton,
  Box,
  Pagination,
  TextField,
  Tooltip,
  LinearProgress
} from "@mui/material";
import { Add, FilterList, Search, Edit, Delete, Visibility, ArrowUpward, ArrowDownward } from "@mui/icons-material";
import { Menu, MenuItem } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import {
  Clear,
} from "@mui/icons-material";
import { BsEye } from "react-icons/bs";

const TableComponent = ({ tableLoading, columns, rowsData, head, addList, actions,showAdd, checked, view, onEdit, onDelete, onView, onCheck, onDeleteALL ,showView, viewList

}) => {
  const rowsPerPage = 18;

  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(1);
  const [filteredData, setFilteredData] = useState([]);
  const [paginatedData, setPaginatedData] = useState([]);
  const [filterAnchor, setFilterAnchor] = useState(null);
  const [columnFilterAnchor, setColumnFilterAnchor] = useState(null);
  const [selectedColumn, setSelectedColumn] = useState(null);
  const [selectedFilter, setSelectedFilter] = useState({});
  const [selectedRows, setSelectedRows] = useState([]);
  const [sortBy, setSortBy] = useState("");
  const [sortDirection, setSortDirection] = useState(SortDirection.ASC);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);

  const handleMenuOpen = (event, row) => {
    setAnchorEl(event.currentTarget);
    setSelectedRow(row);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedRow(null);
  };

  useEffect(() => {
    let newFilteredData = rowsData.filter((row) =>
      columns.some((column) =>
        row[column.field]?.toString().toLowerCase().includes(searchTerm)
      )
    );

    if (sortBy) {
      newFilteredData = [...newFilteredData].sort((a, b) => {
        const valueA = a[sortBy];
        const valueB = b[sortBy];
        if (valueA < valueB) return sortDirection === SortDirection.ASC ? -1 : 1;
        if (valueA > valueB) return sortDirection === SortDirection.ASC ? 1 : -1;
        return 0;
      });
    }

    setFilteredData(newFilteredData);

    const newPaginatedData = newFilteredData.slice(
      (page - 1) * rowsPerPage,
      page * rowsPerPage
    );
    setPaginatedData(newPaginatedData);
  }, [rowsData, columns, searchTerm, page, sortBy, sortDirection]);

  useEffect(() => {
    onCheck(selectedRows)
  }, [selectedRows]);


  const handleSearch = (e) => {
    setSearchTerm(e.target.value.toLowerCase());
    setPage(1);
  };

  const handleSort = ({ sortBy: newSortBy, sortDirection: newSortDirection }) => {
    setSortBy(newSortBy);
    setSortDirection(newSortDirection);
  };

  const handleSelectRow = (rowIndex) => {
    const rowId = paginatedData[rowIndex].id;
    setSelectedRows((prev) =>
      prev.includes(rowId) ? prev.filter((id) => id !== rowId) : [...prev, rowId]
    );

  };

  const handleSelectAll = () => {
    if (selectedRows.length === paginatedData.length) {
      setSelectedRows([]);

    } else {
      setSelectedRows(paginatedData.map((row) => row.id));

    }
  };

  const isRowSelected = (rowIndex) => selectedRows.includes(paginatedData[rowIndex]?.id);

  // Function to render column header with sorting icon
  const renderHeader = (label, field) => {
    const isSorted = sortBy === field;
    return (
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
        {label}
        {isSorted &&
          (sortDirection === SortDirection.ASC ? (
            <ArrowUpward fontSize="small" />
          ) : (
            <ArrowDownward fontSize="small" />
          ))}
      </Box>
    );
  };

  // Function to check if a column is an image column based on its label
  const isImageColumn = (label) =>
    typeof label === 'string' && (label.toLowerCase().includes("image") || label.toLowerCase().includes("profile"));

  // Function to render table cells dynamically
  const renderCell = ({ cellData, columnLabel }) => {
    if (isImageColumn(columnLabel)) {
      return (
        <img
          src={cellData || "https://via.placeholder.com/40"}
          alt="Profile"
          style={{ width: "30px", height: "30px", borderRadius: "50%", objectFit: 'cover' }}
        />
      );
    }
    return cellData;
  };


  const handleFilterOpen = (event) => setFilterAnchor(event.currentTarget);
  const handleFilterClose = () => setFilterAnchor(null);

  const handleColumnFilterOpen = (event, field) => {
    setSelectedColumn(field);
    setColumnFilterAnchor(event.currentTarget);
  };

  const handleColumnFilterClose = () => setColumnFilterAnchor(null);

  const handleFilterSelect = (value) => {
    setSelectedFilter((prev) => {
      const newFilters = { ...prev };
      if (!newFilters[selectedColumn]) {
        newFilters[selectedColumn] = [];
      }
      if (newFilters[selectedColumn].includes(value)) {
        newFilters[selectedColumn] = newFilters[selectedColumn].filter((v) => v !== value);
      } else {
        newFilters[selectedColumn].push(value);
      }
      return { ...newFilters };
    });
  };

  const handleResetFilters = () => setSelectedFilter({});

  useEffect(() => {
    let newFilteredData = rowsData.filter((row) =>
      columns.some((column) =>
        row[column.field]?.toString().toLowerCase().includes(searchTerm)
      )
    );

    Object.keys(selectedFilter).forEach((key) => {
      if (selectedFilter[key].length > 0) {
        newFilteredData = newFilteredData.filter((row) => selectedFilter[key].includes(row[key]));
      }
    });

    if (sortBy) {
      if(sortBy!="select")
      {
        newFilteredData.sort((a, b) => {
          const valueA = a[sortBy];
          const valueB = b[sortBy];
          return sortDirection === SortDirection.ASC ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
        });
      }
    }

    setFilteredData(newFilteredData);
    setPaginatedData(newFilteredData.slice((page - 1) * rowsPerPage, page * rowsPerPage));
  }, [rowsData, columns, searchTerm, page, sortBy, sortDirection, selectedFilter]);


  const DeleteALLRecord = () => {

    onDeleteALL()

  }



  return (
    <>
    <Paper sx={{ padding: 0, marginTop: 2,  overflowX: "auto", }}>
          {tableLoading === true && ( <LinearProgress/> )}
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb:1, background:'#e3e5f6', paddingLeft:1, paddingRight:1}}>
        <Typography variant="h6" sx={{paddingLeft:"1%", color:'#6b009f'}}>{head}</Typography>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          {/* <Tooltip title="Add"><IconButton onClick={addList}><Add /></IconButton></Tooltip> */}
           {showView === true && (
             <Tooltip title="View Yearly Target"><IconButton><BsEye onClick={viewList} /></IconButton></Tooltip>
            )}
            {showAdd === true && (
              <Tooltip title="Add"><IconButton onClick={addList}><Add /></IconButton></Tooltip>
            )}
          <Tooltip title="Filter"> <IconButton onClick={handleFilterOpen}><FilterList /></IconButton></Tooltip>
          <Tooltip title="Reset"> <IconButton onClick={handleResetFilters}><Clear /></IconButton></Tooltip>
          <TextField
  variant="outlined"
  size="small"
  placeholder="Search"
  value={searchTerm}
  onChange={(e) => setSearchTerm(e.target.value.toLowerCase())}
  sx={{
    '& .MuiOutlinedInput-root': {
      borderRadius: '20px!important',
    },
  }}
/>
          {/* Do not remove this (Delete all icon) */}
          {/* <IconButton onClick={DeleteALLRecord}><Delete /></IconButton> */}
        </Box>
      </Box>

      <Menu anchorEl={filterAnchor} open={Boolean(filterAnchor)} onClose={handleFilterClose}>
        {columns.map((col) => (
          <MenuItem key={col.field} onClick={(e) => handleColumnFilterOpen(e, col.field)}>
            {col.label}
          </MenuItem>
        ))}
      </Menu>

      <Menu anchorEl={columnFilterAnchor} open={Boolean(columnFilterAnchor)} onClose={handleColumnFilterClose} sx={{ maxHeight: '600px', overflowY: 'auto' }} >
        {[...new Set(rowsData.map((row) => row[selectedColumn]))].map((value) => (
          <MenuItem key={value} onClick={() => handleFilterSelect(value)} >
            <Checkbox checked={selectedFilter[selectedColumn]?.includes(value) || false} />
            {value}
          </MenuItem>
        ))}
      </Menu>

      {/* Table */}
      {filteredData.length > 0 ? (
        <>
        <>
          <Box sx={{ maxHeight: "500px", overflowY: "hidden", overflowX: "auto", width: "100%", fontSize: '13px' }}>
            <Table
              width={columns.length * 180}
              height={filteredData.length > 10 ? 500 : filteredData.length * 70}
              headerHeight={35}
              rowHeight={30}
              rowCount={paginatedData.length}
              rowGetter={({ index }) => paginatedData[index]}
              sort={handleSort}
              sortBy={sortBy}
              sortDirection={sortDirection}
              rowClassName={() => 'table-row'} 
            >
              {/* Checkbox Column */}
              {checked &&
                <Column
                  label={
                    <Checkbox
                      checked={paginatedData.length > 0 && selectedRows.length === paginatedData.length}
                      indeterminate={selectedRows.length > 0 && selectedRows.length < paginatedData.length}
                      onChange={handleSelectAll}
                    />
                  }
                  dataKey="select"
                  width={50}
                  cellRenderer={({ rowIndex }) => (
                    <Checkbox
                      checked={isRowSelected(rowIndex)}
                      onChange={() => handleSelectRow(rowIndex)}
                      size="small"
                    />
                  )}
                />}

              {/* Dynamic Columns with Image Handling */}
              {columns.map((col) => (
                <Column
                  key={col.field}
                  label={renderHeader(col.label, col.field)}
                  dataKey={col.field}
                  width={200}
                  cellRenderer={({ cellData }) => renderCell({ cellData, columnLabel: col.label })}
                />
              ))}

              {/* Actions  */}
              {actions &&
                <Column
                  label="Actions"
                  dataKey="actions"
                  width={100}
                  cellRenderer={({ rowIndex }) => {
                    const row = paginatedData[rowIndex];
                    return (
                      <Box>
                        <IconButton onClick={(event) => handleMenuOpen(event, row)} size="small">
                          <MoreVertIcon fontSize="small" />
                        </IconButton>

                        <Menu
                          anchorEl={anchorEl}
                          open={Boolean(anchorEl)}
                          onClose={handleMenuClose}
                        >
                          <MenuItem onClick={() => { onEdit(selectedRow); handleMenuClose(); }}>
                            <Edit fontSize="small" sx={{ marginRight: 1 }} />
                            Edit
                          </MenuItem>
                          {/* <MenuItem onClick={() => { onDelete(selectedRow); handleMenuClose(); }}>
                            <Delete fontSize="small" sx={{ marginRight: 1 }} />
                            Delete
                          </MenuItem> */}
                          {view && (
                            <MenuItem onClick={() => { onView(selectedRow); handleMenuClose(); }}>
                              <Visibility fontSize="small" sx={{ marginRight: 1 }} />
                              View
                            </MenuItem>
                          )}
                        </Menu>
                      </Box>
                    );
                  }}
                />}
            </Table>
          </Box>
        </>
      
      </>
      ) : (
        <Box sx={{ height: "90px" }}>
            <Typography mt={4} align="center">No Data Found</Typography>
          </Box>
      )}
       
    </Paper>
     <div style={{ display: 'flex', justifyContent: 'end', paddingBottom:'0%',fontSize:'10px',height:'0px'}}>
     <Pagination
       count={Math.ceil(filteredData.length / rowsPerPage)}
       page={page}
       onChange={(event, value) => setPage(value)}
       variant="outlined"
       shape="rounded"
       sx={{
         marginTop: 2,
         fontSize: '12px',
         '& .MuiPaginationItem-root': {
            fontSize: '11px',
          height: '20px',
          minWidth: '20px',
         }
       }}
     
     />
   </div>
   </>
  );
};

export default TableComponent;